/* UpdateDeviceStatusesVeilComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./UpdateDeviceStatusesVeilRenderer");

const STORAGE_KEYS = {
    STATUS: "lastDeviceStatusUpdate-status",
    COMMENT: "lastDeviceStatusUpdate-comment",
};

class UpdateDeviceStatusesVeilComponent extends EventEmitter {
    constructor(deviceContext, deviceCount) {
        super();
        this._deviceContext = deviceContext || {};
        this._deviceCount = deviceCount || 0;
        this._selectedStatus = "PENDING";
        this._comment = "";

        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        // No listeners needed for now
    }

    _unregisterListeners() {
        // No listeners needed for now
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        const prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._deviceContext = undefined;
        this._deviceCount = undefined;
        this._selectedStatus = undefined;
        this._comment = undefined;
        this._context = undefined;
        return prom;
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    sendResponse(result) {
        this._context.resolve(result);
    }

    cancelAction() {
        this._context.reject({userRejected: true});
    }

    /*******************************************/
    /* END PUBLIC COMPONENT MODEL METHODS      */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    getSelectedStatus() {
        return this._selectedStatus;
    }

    setSelectedStatus(status) {
        this._selectedStatus = status;
    }

    getComment() {
        return this._comment;
    }

    setComment(comment) {
        this._comment = comment;
    }

    getDeviceContext() {
        return this._deviceContext;
    }

    getDeviceCount() {
        return this._deviceCount;
    }

    reuseLastEntry() {
        // Load last status and comment from session storage
        const lastStatus = window.sessionStorage.getItem(STORAGE_KEYS.STATUS);
        const lastComment = window.sessionStorage.getItem(STORAGE_KEYS.COMMENT);

        if (lastStatus) {
            this.setSelectedStatus(lastStatus);
        }
        if (lastComment) {
            this.setComment(lastComment);
        }

        this.emit("ReuseLastEntry", {status: lastStatus, comment: lastComment});
    }

    getData() {
        return {
            status: this._selectedStatus,
            comment: this._comment,
            deviceContext: this._deviceContext,
        };
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = UpdateDeviceStatusesVeilComponent;
